import { useCallback } from 'react'

import { useEmberTransitionTo } from '../../../../../hooks/routing/useEmberTransitionTo'
import { getOrganizationViewUrl } from '../../../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../../../utils/routing/reactRoute'

interface OrganizationRedirectParams {
  organizationUrl: string
}

export const useRedirectAfterCreateOrganization = () => {
  const { transitionTo } = useEmberTransitionTo()

  const redirectAfterCreateOrganization = useCallback(
    ({ organizationUrl }: OrganizationRedirectParams) => {
      transitionTo(getOrganizationViewUrl(organizationUrl, reactRoute.organization.dashboard.getMainRoute()))
    },
    [transitionTo],
  )

  return { redirectAfterCreateOrganization }
}
